import { createFileRoute, redirect } from '@tanstack/react-router'

/** Account mapping moved into the settings hub (pages/settings.md §6.1): old links land there. */
export const Route = createFileRoute('/_app/account-mapping')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/account-mapping', replace: true })
  },
})
